import { Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { isFeatureActive } from '../util/feature-active';

@Pipe({
  name: 'isFeatureActive',
  standalone: true,
  pure: false,
})
export class FeatureActivePipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(featureName: string): boolean {
    const location = this.languageService.locationCode;

    return isFeatureActive(location, featureName);
  }
}
